import useNotificationFactory from './useNotificationFactory.js';
import useNotificationUnmount from './useNotificationUnmount.js';
export default function useNotification(data, onUnmount) {
    const notification = useNotificationFactory(data);
    useNotificationUnmount(notification, onUnmount);
    return notification;
}
//# sourceMappingURL=useNotification.js.map